import { useEffect, useState } from "react"
import { config } from "../config"

export function useTabletBreakpoint(): boolean {
  const [breakPointTriggered, setBreakpointTriggered] = useState<boolean>(window.innerWidth <= config.tabletBreakpoint)

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    handleResize()

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  function handleResize(): void {
    setBreakpointTriggered(window.innerWidth <= config.tabletBreakpoint)
  }

  return breakPointTriggered
}
